import styled from 'styled-components';

import { IconTick } from '@xing-com/icons';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

export const Button = styled.button<{ $primary: string; $secondary: string }>`
  background-color: ${(props) => props.$primary};
  width: 36px;
  height: 36px;
  border: ${(props) => `5px solid ${props.$secondary}`};
  border-radius: 50%;
  margin: 0 5px;
  padding: 1px 0 0 0;
  cursor: pointer;
  flex-shrink: 0;

  @media ${mediaSmallOrTiny} {
    border: ${(props) => `3px solid ${props.$secondary}`};
    width: 24px;
    height: 24px;
  }
`;

export const Wrapper = styled.div``;

export const Marked = styled(IconTick)`
  color: #fff;
  width: 100%;
  height: 100%;
`;
